export default __webpack_public_path__ + "static/NoAccidents-037c4fcfe6b040fdb928b7842be37eb1.svg";